import React, { useState, useEffect } from 'react'
import Banners from "../../asset/images/banners/homebanner.jpg"
import Banner2 from "../../asset/images/banners/homebanner1.png"
import Banner3 from "../../asset/images/banners/homebanner2.jpg"
import styles from "../../asset/banner/banner.module.scss";

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const banners = [
    { 
      id: 1, 
      image: Banners, 
      alt: "Home Banner 1",
      title: "Resource-rich infrastructure",
      description: "backed by broad technology bandwidth",
      buttonText: "Know Our Work",
      link: "/Portfolio"
    },
    { 
      id: 2, 
      image: Banner2, 
      alt: "Home Banner 2",
      title: "Production ready solutions",
      description: "for promotional products, apparel and sportswear manufacturers",
      buttonText: "Explore Our Services",
      link: "/service"
    },
    { 
      id: 3, 
      image: Banner3, 
      alt: "Home Banner 3",
      title: "Prompt & clear communication",
      description: "in a responsive support environment",
      buttonText: "Discover Now",
      link: "/about"
    }
  ];

  // Create infinite loop array: [last, ...original, first]
  const infiniteBanners = [
    banners[banners.length - 1],
    ...banners,
    banners[0]
  ];

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide(prev => prev + 1);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide(prev => prev - 1);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isTransitioning) {
        nextSlide();
      }
    }, 4000);
    return () => clearInterval(interval);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTransitioning(false);
      if (currentSlide >= banners.length + 1) {
        setCurrentSlide(1);
      } else if (currentSlide <= 0) {
        setCurrentSlide(banners.length);
      }
    }, 600);

    return () => clearTimeout(timer);
  }, [currentSlide, banners.length]);

  return (
    <div className={styles.banner}>
      {/* <button className={`${styles.navButton} ${styles.prevButton}`} onClick={prevSlide}>
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
        </svg>
      </button> */}
      
      <div className={styles.bannerCarousel}>
        <div 
          className={styles.bannerTrack}
          style={{ 
            transform: `translateX(-${currentSlide * 20}%)`,
            transition: isTransitioning ? 'transform 0.6s ease' : 'none'
          }}
        >
          {infiniteBanners.map((banner, index) => (
            <div key={`${banner.id}-${index}`} className={styles.bannerSlide}>
              <img 
                className={styles.bannerimg} 
                src={banner.image} 
                alt={banner.alt} 
              />
              <div className={styles.bannerOverlay}></div>
              <div className={styles.bannerContent}>
                <h2 className={styles.bannerTitle}>{banner.title}</h2>
                <p className={styles.bannerDescription}>{banner.description}</p>
                <button 
                  className={styles.exploreButton}
                  onClick={() => window.location.href = banner.link}
                >
                  {banner.buttonText}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* <button className={`${styles.navButton} ${styles.nextButton}`} onClick={nextSlide}>
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
        </svg>
      </button> */}
      
      <div className={styles.dots}>
        {banners.map((_, index) => (
          <button 
            key={index}
            className={`${styles.dot} ${(currentSlide - 1) === index ? styles.active : ''}`}
            onClick={() => {
              if (!isTransitioning) {
                setIsTransitioning(true);
                setCurrentSlide(index + 1);
              }
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default Banner